import { MenuItem } from '@mui/material';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { RootState } from '@/store';
import { SCREEN_SM } from '@/theme/screens';
import { formatCreditsText } from '@/utils';

import CountBox from '../CountBox';
import IconMenu from '../IconMenu';
import Link from '../Link';
import MediaQuery from '../MediaQuery';
import MemberList from '../MemberList';
import s from './TeamPreview.module.scss';

interface TeamNavProps {
  team: any;
}

class TeamNav extends PureComponent<TeamNavProps> {
  render() {
    const { team } = this.props;
    const { billing_account: billingAccount } = team;

    return (
      <IconMenu>
        <Link to={team.html_url}>
          <MenuItem>View Team</MenuItem>
        </Link>
        {billingAccount && (
          <Link to={`${team.html_url}/settings/billing`}>
            <MenuItem>Billing</MenuItem>
          </Link>
        )}
      </IconMenu>
    );
  }
}

function formatSeatsText(used: number, included: number): string {
  return `${used} of ${included} ${included === 1 ? 'seat' : 'seats'} allocated`;
}

function TeamPreview({ team }: any) {
  const { name, html_url: htmlUrl, stats, billing_account: billingAccount } = team;
  const isSMB = billingAccount?.isSMBAccount;
  const seatAllocation = billingAccount?.seatAllocation;
  const balance = billingAccount && billingAccount.credit_balance;
  const credits = (balance && balance.cents) || 0;

  const total = team.members && team.members.pageInfo ? team.members.pageInfo.total : 0;
  const expertRequestCount = stats ? stats.expert_request_count : 0;
  const consultationCount = stats ? stats.consultation_count : 0;

  return (
    <MediaQuery maxWidth={SCREEN_SM}>
      {(isMobileVersion: any) => {
        const members =
          team.members && !isMobileVersion ? team.members.edges.map((e: any) => e.node) : [];

        return (
          <div className={s.root}>
            <div className={s.header}>
              <h3 className={s.name}>
                <Link to={htmlUrl}>{name}</Link>
              </h3>
              <MemberList
                members={members}
                membersDisplayLimit={isMobileVersion ? 0 : 4}
                total={total}
                htmlUrl={htmlUrl}
              />
            </div>

            <div className={s.subHeader}>
              {isSMB && seatAllocation
                ? formatSeatsText(seatAllocation.used ?? 0, seatAllocation.included ?? 0)
                : formatCreditsText(credits)}
            </div>

            <div className={s.footer}>
              <div className={s.counters}>
                <CountBox
                  grayOutZero
                  className={s.countBox}
                  count={expertRequestCount}
                  label="Requests"
                  linkTo={htmlUrl}
                />
                <CountBox
                  grayOutZero
                  className={s.countBox}
                  count={consultationCount}
                  label="Calls"
                  linkTo={htmlUrl}
                />
              </div>
              <TeamNav team={team} />
            </div>
          </div>
        );
      }}
    </MediaQuery>
  );
}

export default connect((state: RootState) => ({
  viewer: state.viewer,
}))(TeamPreview);
